export * from "./components/message";
export * from "./message.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/collections/message/index.js
// module id = 471
// module chunks = 0